var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsUUID, } from 'class-validator';
import { ExerciseProgramItemFullSizeDto } from '../../exercise-programs/index.js';
import { TrainingSessionItemEval } from '../enums/training-session-item-eval.enum.js';
import { TrainingSessionItemTrackingFullSizeDto } from './training-session-item-tracking.full-size.dto.js';
import { TrainingSessionFullSizeDto } from './training-session.full-size.dto.js';
export class TrainingSessionItemFullSizeDto {
    id;
    createdAt;
    updatedAt;
    exerciseProgramItemId;
    trainingSessionId;
    sortIndex;
    evaluation;
    exerciseProgramItem;
    trainingSession;
    trainingSessionItemTrackings;
    /**
     * The user ID of the user who created the training session.
     */
    get userId() {
        return this.trainingSession?.exerciseProgram?.userId || null;
    }
    /**
     * The office ID of the user who created the training session.
     */
    get userOfficeId() {
        return this.trainingSession?.exerciseProgram?.user?.officeId || null;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionItemFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionItemFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemFullSizeDto.prototype, "exerciseProgramItemId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemFullSizeDto.prototype, "trainingSessionId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TrainingSessionItemFullSizeDto.prototype, "sortIndex", void 0);
__decorate([
    IsOptional(),
    IsEnum(TrainingSessionItemEval),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionItemFullSizeDto.prototype, "evaluation", void 0);
__decorate([
    IsObject(),
    Type(() => ExerciseProgramItemFullSizeDto),
    Expose(),
    __metadata("design:type", ExerciseProgramItemFullSizeDto)
], TrainingSessionItemFullSizeDto.prototype, "exerciseProgramItem", void 0);
__decorate([
    IsObject(),
    Type(() => TrainingSessionFullSizeDto),
    Exclude(),
    __metadata("design:type", TrainingSessionFullSizeDto)
], TrainingSessionItemFullSizeDto.prototype, "trainingSession", void 0);
__decorate([
    IsArray(),
    Type(() => TrainingSessionItemTrackingFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], TrainingSessionItemFullSizeDto.prototype, "trainingSessionItemTrackings", void 0);
//# sourceMappingURL=training-session-item.full-size.dto.js.map